var _path, _ellipse, _circle, _circle2, _circle3, _ellipse2, _circle4, _path2, _path3, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 71,
    viewBox: "0 0 355 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.434 18.695L35.367 51.077M66.969 51.077L52.433 18.695M66.969 51.076L35.366 29.53M18.17 18.695l17.197 32.382M4.089 51.076L35.367 29.53M18.168 18.695L4.086 51.077",
    stroke: "#2B2A9E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.396,
    cy: 18.695,
    rx: 4.056,
    ry: 4.023,
    fill: "#504FE9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.023,
    transform: "matrix(-1 0 0 1 52.5 18.695)",
    fill: "#504FE9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.367,
    cy: 51.008,
    r: 4.023,
    fill: "#504FE9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.367,
    cy: 29.602,
    r: 4.023,
    fill: "#504FE9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.056,
    cy: 51.016,
    rx: 4.056,
    ry: 4.023,
    fill: "#504FE9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4.023,
    transform: "matrix(-1 0 0 1 66.84 51.008)",
    fill: "#504FE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.128 25.823c.373 0 .658.118.854.353.216.216.324.51.324.883v18.63c0 .353-.098.637-.295.853-.196.216-.471.324-.824.324s-.618-.108-.794-.324c-.177-.216-.265-.5-.265-.853v-15.04l-6.387 12.244c-.274.569-.677.853-1.206.853-.51 0-.913-.284-1.207-.853l-6.416-12.096v14.892c0 .353-.098.637-.294.853-.177.216-.441.324-.795.324-.353 0-.627-.108-.824-.324-.196-.216-.294-.5-.294-.853v-18.63c0-.373.108-.667.324-.883.216-.235.51-.353.883-.353.49 0 .882.285 1.177.854l7.475 14.332 7.387-14.332c.157-.314.324-.53.501-.648.196-.137.421-.206.676-.206zm27.719 19.513c.078.157.117.323.117.5 0 .294-.117.54-.353.736-.216.196-.48.294-.794.294-.491 0-.834-.236-1.03-.706l-2.09-4.768h-11.095l-2.119 4.768c-.197.47-.54.706-1.03.706-.314 0-.589-.098-.824-.294a1.005 1.005 0 01-.236-1.236l8.417-18.718c.118-.275.295-.48.53-.618a1.49 1.49 0 01.765-.206c.294 0 .559.078.795.235.235.137.412.334.53.589l8.417 18.718zm-14.362-5.945h9.329l-4.679-10.566-4.65 10.566zm34.759-12.95c.099-.216.236-.382.413-.5.196-.118.402-.177.618-.177.313 0 .588.108.824.324.255.196.382.441.382.736 0 .157-.039.314-.118.47l-8.446 18.777a1.288 1.288 0 01-.53.589 1.49 1.49 0 01-.765.206 1.49 1.49 0 01-.765-.206 1.288 1.288 0 01-.53-.589l-8.417-18.776a1.257 1.257 0 01-.088-.442c0-.314.127-.569.382-.765a1.29 1.29 0 01.854-.324c.471 0 .814.226 1.03.677l7.593 17.158 7.563-17.158zm9.872 20.425c-.373 0-.667-.108-.883-.324-.216-.235-.324-.54-.324-.912V27.06c0-.374.108-.668.324-.884.216-.235.51-.353.883-.353.372 0 .667.118.883.353.215.216.323.51.323.883v18.57c0 .374-.108.678-.323.913-.216.216-.511.324-.883.324zm25.365-21.043c.353 0 .627.118.824.353.196.216.294.51.294.883v18.57c0 .374-.108.678-.324.913-.196.216-.481.324-.853.324-.373 0-.697-.167-.972-.5l-12.213-16.334V45.63c0 .373-.108.677-.324.912-.196.216-.471.324-.824.324s-.628-.108-.824-.324c-.196-.235-.294-.54-.294-.912V27.06c0-.374.098-.668.294-.884.216-.235.51-.353.883-.353.392 0 .726.167 1.001.5l12.184 16.334V27.06c0-.373.098-.667.294-.883.216-.235.5-.353.854-.353z",
    fill: "#2B2A9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.651 44.982c.196.216.294.461.294.736 0 .314-.117.579-.353.795a1.18 1.18 0 01-.824.324c-.314 0-.598-.138-.853-.413l-6.71-8.564-6.74 8.564c-.216.275-.5.413-.853.413-.295 0-.56-.108-.795-.324-.235-.236-.353-.5-.353-.795 0-.294.088-.54.265-.736l7.063-8.858-6.681-8.417a1.1 1.1 0 01-.294-.765c0-.295.108-.55.324-.766.235-.215.5-.323.794-.323.334 0 .618.147.854.441l6.416 8.123 6.386-8.123c.235-.294.52-.441.854-.441.294 0 .559.117.794.353.236.216.353.48.353.794 0 .275-.088.51-.265.707l-6.71 8.417 7.034 8.858z",
    fill: "#504FE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__filter0_d_3121_17060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.145 25.305c1.023-1.655 4.4-4.889 9.727-4.581 6.658.383 9.579 3.598 11.026 3.952 1.379.583 6.625 2.333 15.621-.446l-.23 10.976-.281 13.424c-2.513.75-8.605 1.734-12.863-.329-1.21-.736-4.201-2.43-6.493-3.318l-.025-.01c-2.146-.831-5.196-2.013-8.218-1.459.466.52 2.447 1.43 3.378 1.82-1.624 1.61-5.265 4.922-6.831 5.296-1.567.374-1.99-.878-2.003-1.587l-1.404-11.869-1.404-11.869z",
    fill: "#FED430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.951 49.044c-.172-1.455 1.34-3.492 2.463-4.31a7.842 7.842 0 012.993-1.218c.467.52 2.447 1.43 3.379 1.82-1.625 1.609-5.266 4.922-6.832 5.295-1.567.374-1.989-.877-2.003-1.587z",
    fill: "#DDB92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.872 20.716c-5.327-.307-8.704 2.926-9.727 4.581l1.404 11.87c.148-1.245 1.324-3.997 4.836-5.055 4.39-1.322 6.708.007 9.675 1.516 2.966 1.508 6.122 4.042 11.903 3.943 1.782-.062 5.942-.623 8.326-2.373l.23-10.976c-8.996 2.78-14.242 1.03-15.621.446-1.447-.354-4.368-3.568-11.026-3.952z",
    fill: "#0C5EB8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__filter1_d_3121_17060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.519 25.305c1.023-1.655 4.4-4.889 9.728-4.581 6.658.383 9.578 3.598 11.025 3.952 1.38.583 6.626 2.333 15.621-.446l-.23 10.976-.28 13.424c-2.514.75-8.605 1.734-12.864-.329-1.21-.736-4.2-2.43-6.493-3.318l-.024-.01c-2.147-.831-5.196-2.013-8.218-1.459.466.52 2.446 1.43 3.378 1.82-1.625 1.61-5.265 4.922-6.832 5.296-1.567.374-1.99-.878-2.003-1.587l-1.404-11.869-1.404-11.869z",
    fill: "#EB040E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.325 49.044c-.172-1.455 1.34-3.492 2.464-4.31a7.835 7.835 0 012.993-1.218c.466.52 2.446 1.43 3.378 1.82-1.624 1.609-5.265 4.922-6.832 5.295-1.566.374-1.989-.877-2.002-1.587z",
    fill: "#AD0F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.247 20.716c-5.327-.307-8.705 2.926-9.728 4.581l1.404 11.87c.149-1.245 1.324-3.997 4.836-5.055 4.39-1.322 6.709.007 9.675 1.516 2.966 1.508 6.123 4.042 11.903 3.942 1.783-.061 5.943-.622 8.327-2.372l.23-10.976c-8.996 2.78-14.243 1.03-15.622.446-1.447-.354-4.367-3.568-11.025-3.952z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__filter0_d_3121_17060",
    x: 226.145,
    y: 0.695,
    width: 76.374,
    height: 70.008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.223514 0 0 0 0 0.220817 0 0 0 0 0.636127 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3121_17060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3121_17060",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__filter1_d_3121_17060",
    x: 278.519,
    y: 0.695,
    width: 76.374,
    height: 70.008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.223514 0 0 0 0 0.220817 0 0 0 0 0.636127 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3121_17060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3121_17060",
    result: "shape"
  })))));
}
export default SvgLogo;